<app-core-offcanvas
  [headerTitle]="('definition.patient.page-title' | translate) + header"
  (chooseOn)="mode === 'edit' ? update() : save()"
  [saveText]="(mode === 'edit' ? 'common.update' : 'common.save') | translate"
  (closed)="cancel()"
  [width]="'100%'"
  #canvas
>
  <div class="instituation-container">
    <div class="sidebar">
      <button
        class="sidebar-button"
        [class.active]="selectedTab === 'patient'"
        (click)="setTab('patient')"
      >
        <i class="la la-home sidebar-icon"></i>
        <span class="sidebar-text">Kişi Bilgileri</span>
      </button>
      <button
        class="sidebar-button"
        [class.active]="selectedTab === 'specialCategoryTags'"
        (click)="setTab('specialCategoryTags')"
      >
        <i class="la la-sticky-note sidebar-icon"></i>
        <span class="sidebar-text">Özel Kategori ve Etiketleri</span>
      </button>
      <button
        *ngIf="updatedId"
        class="sidebar-button"
        [class.active]="selectedTab === 'case'"
        (click)="setTab('case')"
      >
        <i class="la la-car sidebar-icon"></i>
        <span class="sidebar-text">Vaka Bilgileri</span>
      </button>
    </div>
    <div class="content">
      <div [hidden]="selectedTab !== 'patient'">
        <div class="row" [formGroup]="patientForm">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
              <app-cards
                [title]="'definition.patient.general-info' | translate"
                footerDivider="border-0 pb-0 "
                class="custom-cardbox-area"
              >
                <div bodyContent class="row">
                  <div
                    class="col-12 d-flex flex-column justify-content-between mb-2"
                  >
                    <div
                      *ngIf="isSuccess"
                      class="text-success d-flex align-items-center"
                    >
                      <div>
                        <svg
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="me-2"
                        >
                          <polyline points="9 11 12 14 22 4"></polyline>
                          <path
                            d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                          ></path>
                        </svg>
                      </div>
                      <div class="">
                        <strong>{{ "mernis.verified" | translate }}.</strong>
                      </div>
                    </div>
                    <div
                      *ngIf="!isSuccess"
                      class="text-info d-flex align-items-center"
                    >
                      <div class="">
                        <svg
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="me-2"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="16" x2="12" y2="12"></line>
                          <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                      </div>
                      <div class="">
                        <strong>{{ "mernis.not-verified" | translate }}</strong>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mb-2">
                    <app-mernis-query
                      [isQueryMade]="isQueryMade"
                      [isSuccess]="isSuccess"
                      (queryResult)="handleQueryResult($event)"
                      [isFormInvalid]="patientForm.invalid"
                      [isSubmitTriggered]="isSubmitTriggered"
                      #mernisQuery
                    ></app-mernis-query>
                  </div>

                  <div class="col-6 mb-2 align-content-end">
                    <div
                      class="form-check form-switch d-flex justify-content-between p-0"
                    >
                      <label class="form-check-label" for="isForeignNational"
                        >{{
                          "definition.staff.is-foreign-national" | translate
                        }}
                      </label>
                      <input
                        class="form-check-input"
                        formControlName="isForeignNational"
                        type="checkbox"
                        role="switch"
                        id="isForeignNational"
                        aria-checked="true"
                      />
                    </div>
                  </div>

                  <div class="col-6 mb-2 justify-content-end">
                    <div *ngIf="updatedId">
                      <label for="">Yaş:</label>
                      <span class="ms-2">{{ calculatedAge }}</span>
                    </div>
                  </div>

                  <div *ngIf="showPassportField" class="col-6 mb-2">
                    <label class="form-label required-star" for="">{{
                      "definition.staff.country" | translate
                    }}</label>

                    <p-dropdown
                      [options]="countries"
                      [filter]="'name'"
                      [placeholder]="'definition.staff.country' | translate"
                      formControlName="countryId"
                      [showClear]="true"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                    >
                      <ng-template let-country pTemplate="item">
                        <div class="country-option d-flex align-items-center">
                          <div [innerHtml]="country.flag | safeHtml"></div>
                          <span>{{ country.label }}</span>
                        </div>
                      </ng-template>
                    </p-dropdown>
                    <div
                      *ngIf="
                        isSubmit && patientForm.controls['countryId'].errors
                      "
                      class="required"
                    >
                      {{ "validation.required" | translate }}
                    </div>
                  </div>

                  <div *ngIf="showPassportField" class="col-6 mb-2">
                    <label for="passportNo" class="form-label"
                      >{{ "definition.staff.passport-no" | translate
                      }}<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      formControlName="passportNo"
                      id="passportNo"
                      [placeholder]="'definition.staff.passport-no' | translate"
                    />

                    <div
                      *ngIf="
                        isSubmit && patientForm.controls['passportNo'].errors
                      "
                      class="required"
                    >
                      {{ "validation.required" | translate }}
                    </div>
                  </div>

                  <div class="col-6 mb-2">
                    <label for="firstName" class="form-label required-star">{{
                      "definition.staff.first-name" | translate
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="firstName"
                      formControlName="firstName"
                      [placeholder]="'definition.staff.first-name' | translate"
                    />
                    <div
                      *ngIf="
                        isSubmit && patientForm.controls['firstName'].errors
                      "
                      class="required"
                    >
                      {{ "validation.required" | translate }}
                    </div>
                  </div>

                  <div class="col-6 mb-2">
                    <label for="lastName" class="form-label required-star">{{
                      "definition.staff.last-name" | translate
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="lastName"
                      formControlName="lastName"
                      [placeholder]="'definition.staff.last-name' | translate"
                    />
                    <div
                      *ngIf="
                        isSubmit && patientForm.controls['lastName'].errors
                      "
                      class="required"
                    >
                      {{ "validation.required" | translate }}
                    </div>
                  </div>

                  <div class="col-6 mb-2">
                    <label for="mothersName" class="form-label">{{
                      "definition.patient.mothers-name" | translate
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="mothersName"
                      formControlName="mothersName"
                      [placeholder]="
                        'definition.patient.mothers-name' | translate
                      "
                    />
                  </div>

                  <div class="col-6 mb-2">
                    <label for="fathersName" class="form-label">{{
                      "definition.patient.fathers-name" | translate
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="fathersName"
                      formControlName="fathersName"
                      [placeholder]="
                        'definition.patient.fathers-name' | translate
                      "
                    />
                  </div>

                  <div class="col-6 mb-2">
                    <label for="birthPlace" class="form-label">{{
                      "definition.patient.birth-place" | translate
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="birthPlace"
                      formControlName="birthPlace"
                      [placeholder]="
                        'definition.patient.birth-place' | translate
                      "
                    />
                  </div>

                  <div class="col-6 mb-2">
                    <label class="form-label" for="">{{
                      "definition.staff.gender" | translate
                    }}</label>

                    <p-dropdown
                      [options]="genders"
                      [placeholder]="'definition.staff.gender' | translate"
                      formControlName="gender"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                    >
                    </p-dropdown>
                  </div>

                  <div class="col-6 mb-2">
                    <label class="form-label" for="">{{
                      "definition.patient.marital-status" | translate
                    }}</label>

                    <p-dropdown
                      [options]="maritalStatuses"
                      [placeholder]="
                        'definition.patient.marital-status' | translate
                      "
                      formControlName="maritalStatus"
                      [showClear]="true"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                    >
                    </p-dropdown>
                  </div>
                </div>
              </app-cards>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
              <app-cards
                [title]="'definition.patient.medical-info' | translate"
                footerDivider="border-0 pb-0 "
                class="custom-cardbox-area"
              >
                <div class="row" bodyContent>
                  <div class="col-xl-12">
                    <label class="form-check-label form-label" for="">{{
                      "shared-components.medical-records" | translate
                    }}</label>
                    
                     <!-- [icdCodes]="icdCodes" -->
                    <app-medical-records
                      [medicalRecords]="medicalRecords"
                      (medicalRecordsChange)="updateMedicalRecords($event)"
                      #medicalRecord
                    ></app-medical-records>
                  </div>
                </div>
              </app-cards>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
              <app-cards
                [title]="'definition.patient.contact-info' | translate"
                footerDivider="border-0 pb-0 "
                class="custom-cardbox-area"
              >
                <div class="row" bodyContent>
                  <div class="col-xl-12 mb-2">
                    <app-phone-list
                      #phoneList
                      [phones]="phones"
                      [types]="phoneTypes"
                      (phoneItemsChange)="updatePhoneItems($event)"
                      [title]="'definition.staff.phone-numbers' | translate"
                      [form]="patientForm"
                      [isSubmit]="isSubmit"
                    ></app-phone-list>
                  </div>

                  <div class="col-xl-12 mb-2">
                    <app-address-list
                      #addressList
                      [addresses]="addresses"
                      [titles]="titles"
                      (addressItemsChange)="updateAddresses($event)"
                      [form]="patientForm"
                      [isSubmit]="isSubmit"
                    ></app-address-list>
                  </div>

                  <div class="col-xl-12 mb-2">
                    <app-email-list
                      #emailList
                      [emails]="emailItems"
                      [types]="emailTypes"
                      (emailItemsChange)="updateEmailItems($event)"
                      [form]="patientForm"
                      [isSubmit]="isSubmit"
                    ></app-email-list>
                  </div>
                </div>
              </app-cards>
            </div>
          </div>
        </div>
      </div>
      <!-- Vaka Hareketleri -->
      <div [hidden]="selectedTab !== 'case'">
        <div class="mb-2 mt-4 d-flex-between">
          <div class="d-grid">
            <h3 class="mb-0">
              {{ "definition.patient.case.table-name" | translate }}
            </h3>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{ "general.start-date" | translate }}</label>
            <p-calendar
              [(ngModel)]="caseFilter.startDate"
              [placeholder]="'general.start-date' | translate"
              [showTime]="false"
              [showButtonBar]="true"
              appendTo="body"
              #startCalendar
            />
          </div>

          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{ "general.end-date" | translate }}</label>
            <p-calendar
              [(ngModel)]="caseFilter.endDate"
              [placeholder]="'general.end-date' | translate"
              [showTime]="false"
              [showButtonBar]="true"
              appendTo="body"
              #startCalendar
            />
          </div>

          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{ "definition.patient.case.status" | translate }}</label>
            <p-dropdown
              [options]="caseStatuses"
              [(ngModel)]="caseFilter.caseStatus"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              [placeholder]="'definition.patient.case.status' | translate"
            ></p-dropdown>
          </div>

          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{ "definition.patient.case.type" | translate }}</label>
            <p-dropdown
              [options]="caseTypes"
              [(ngModel)]="caseFilter.caseType"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              [placeholder]="'definition.patient.case.type' | translate"
            ></p-dropdown>
          </div>

          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{
              "definition.patient.case.receiving-institution" | translate
            }}</label>
            <p-dropdown
              [options]="instituationList"
              [(ngModel)]="caseFilter.pickupInstitution"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              [placeholder]="
                'definition.patient.case.receiving-institution' | translate
              "
            ></p-dropdown>
          </div>

          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{
              "definition.patient.case.releasing-institution" | translate
            }}</label>
            <p-dropdown
              [options]="instituationList"
              [(ngModel)]="caseFilter.dropoffInstitution"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              [placeholder]="
                'definition.patient.case.releasing-institution' | translate
              "
            ></p-dropdown>
          </div>

          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{
              "definition.patient.case.calling-institution" | translate
            }}</label>
            <p-dropdown
              [options]="instituationList"
              [(ngModel)]="caseFilter.callingInstitution"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              [placeholder]="
                'definition.patient.case.calling-institution' | translate
              "
            ></p-dropdown>
          </div>

          <div class="col-xl-12 d-flex justify-content-end mt-3">
            <button
              class="btn btn-danger light"
              (click)="clearFilter()"
              type="button"
            >
              {{ "general.clear-filter" | translate }}
            </button>
            <button
              class="btn btn-info ms-2"
              type="button"
              (click)="getCaseList({})"
            >
              {{ "general.filtering" | translate }}
              <i class="fa fa-search ms-2"></i>
            </button>
          </div>
        </div>

        <div class="custom-tab-1">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link active" data-bs-toggle="tab" href="#list">{{
                "definition.patient.case.list-title" | translate
              }}</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#analise">{{
                "definition.patient.case.analise-title" | translate
              }}</a>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane fade show active" id="list" role="tabpanel">
              <div class="table-responsive active-projects style-1">
                <div class="d-flex justify-content-end mb-2">
                  <button class="btn btn-success" *ngIf="caseList?.length" (click)="exportToExcel()">
                    Excel'e Aktar
                  </button>
                </div>
                <div id="user-tbl_wrapper" class="dataTables_wrapper no-footer">
                  <p-table
                    [rowHover]="true"
                    responsiveLayout="stack"
                    [rows]="rows"
                    [first]="first"
                    [totalRecords]="totalCaseRecords"
                    [lazy]="true"
                    (onLazyLoad)="getCaseList($event)"
                    paginatorDropdownAppendTo="body"
                    [value]="caseList"
                    [paginator]="true"
                    [scrollable]="true"
                    scrollHeight="50vh"
                    [rowsPerPageOptions]="[10, 20, 30]"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th pSortableColumn="id" style="width: 10%;" scope="col">
                          <span class="p-column-title"
                            >{{ "common.id" | translate }}
                            <p-sortIcon field="id"
                          /></span>
                        </th>
                        <th pSortableColumn="protocolNo" style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{ "instituation.case.protocol-no" | translate }}
                            <p-sortIcon field="protocolNo"
                          /></span>
                        </th>
                        <th pSortableColumn="caseDate" style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{ "instituation.case.case-date" | translate }}
                            <p-sortIcon field="caseDate"
                          /></span>
                        </th>
                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{ "instituation.case.case-type" | translate }}
                          </span>
                        </th>

                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{ "instituation.case.case-status" | translate }}
                          </span>
                        </th>

                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{ "instituation.case.name-surname" | translate }}
                          </span>
                        </th>

                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{
                              "instituation.case.taken-instituation" | translate
                            }}
                          </span>
                        </th>

                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{
                              "instituation.case.left-instituation" | translate
                            }}
                          </span>
                        </th>

                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{
                              "instituation.case.call-instituation" | translate
                            }}
                          </span>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-list>
                      <tr>
                        <td>{{ list?.id }}</td>
                        <td>
                          <a
                            [routerLink]="['/case/' + list.id]"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {{ list?.caseNo }}
                          </a>
                        </td>
                        <td>{{ list?.caseDate | dateFormat : true }}</td>
                        <td>{{ list?.caseType?.valueObject?.name?.value }}</td>
                        <td>
                          <span
                            class="badge light border-0 badge-{{
                              list?.caseStatus === 'started' ||
                              list?.caseStatus === 'finished'
                                ? 'success'
                                : 'danger'
                            }}"
                          >
                            {{ list?.caseStatus | caseStatusPipe }}
                          </span>
                        </td>
                        <td>
                          {{
                            (list?.patientInformations?.firstName ?? "") +
                              " " +
                              (list?.patientInformations?.lastName ?? "")
                          }}
                        </td>
                        <td>
                          {{
                            list?.addressInformations?.pickupInstitution
                              ?.signboard
                          }}
                        </td>
                        <td>
                          {{
                            list?.addressInformations?.dropoffInstitution
                              ?.signboard
                          }}
                        </td>
                        <td>
                          {{ list?.caseInformations?.institution?.signboard }}
                        </td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="paginatorleft">
                      {{ totalCaseRecords }}
                      {{ "common.table.totalFound" | translate }}
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="99">{{ "common.noData" | translate }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="analise">
              <div class="mt-2">
                <div class="info-boxes-grid">
                  <div class="info-box" style="border-left-color: #2563eb">
                    <div class="box-header" style="background-color: #2563eb10">
                      <h2 class="box-title">
                        {{
                          "definition.patient.case.receiving-institution"
                            | translate
                        }}
                      </h2>
                    </div>

                    <div class="box-content">
                      <div
                        class="institution-item"
                        *ngFor="
                          let institution of caseAnalise.pickupInstitutions
                        "
                      >
                        <div class="institution-info">
                          <span class="institution-name">{{
                            institution?.signboard
                          }}</span>
                          <span
                            class="institution-count"
                            style="color: #2563eb"
                          >
                            {{ institution?.count }} adet
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-box" style="border-left-color: #ea580c">
                    <div class="box-header" style="background-color: #ea580c10">
                      <h2 class="box-title">
                        {{
                          "definition.patient.case.releasing-institution"
                            | translate
                        }}
                      </h2>
                    </div>

                    <div class="box-content">
                      <div
                        class="institution-item"
                        *ngFor="
                          let institution of caseAnalise.dropoffInstitutions
                        "
                      >
                        <div class="institution-info">
                          <span class="institution-name">{{
                            institution?.signboard
                          }}</span>
                          <span
                            class="institution-count"
                            style="color: #ea580c"
                          >
                            {{ institution?.count }} adet
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-box" style="border-left-color: #059669">
                    <div class="box-header" style="background-color: #05966910">
                      <h2 class="box-title">
                        {{
                          "definition.patient.case.calling-institution"
                            | translate
                        }}
                      </h2>
                    </div>

                    <div class="box-content">
                      <div
                        class="institution-item"
                        *ngFor="
                          let institution of caseAnalise.callingInstitution
                        "
                      >
                        <div class="institution-info">
                          <span class="institution-name">{{
                            institution?.signboard
                          }}</span>
                          <span
                            class="institution-count"
                            style="color: #059669"
                          >
                            {{ institution?.count }} adet
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Özel Kategori Sekmesi -->
      <div [hidden]="selectedTab !== 'specialCategoryTags'">
        <div class="row" [formGroup]="patientForm">
          <div class="col-12 mt-3">
            <app-cards title="Özel Kategori Bilgileri" footerDivider="border-0 pb-0" class="custom-cardbox-area">
              <div class="row" bodyContent>
                <!-- Özel Kategori -->
                <div class="col-3 mb-4">
                  <label class="form-label">
                    {{ "definition.patient.category" | translate }}
                  </label>
      
                  <div class="d-flex align-items-center">
                    <p-multiSelect [options]="category" [placeholder]="'definition.patient.category' | translate"
                      formControlName="categoryId" appendTo="body" [showClear]="true" optionLabel="label" optionValue="value"
                      display="chip" class="flex-grow-1 me-2">
                    </p-multiSelect>
      
                    <a type="button" target="_blank" class="btn btn-primary btn-icon-xxs"
                      href="/definition/parameter/data-group/patient-category" title="İlgili Tanım Ekranına Git">
                      <i class="fa fa-external-link"></i>
                    </a>
                  </div>
                </div>
                <div class="col-1 mb-4"></div>
      
                <!-- Özel Kategori Etiketleri -->
                <div class="col-12 mb-4">
                  <div class="special-tag-section compact">
                    <div class="special-tag-toolbar">
                      <div>
                        <h5 class="special-tag-title mb-1">Özel Kategori Etiketleri</h5>
                        <span class="special-tag-subtitle">
                          Etiket, alarm ve pasif durumunu yönetin.
                        </span>
                      </div>
      
                      <button type="button" class="special-tag-add-btn" [class.disabled]="hasEmptySpecialCategoryTag()"
                        (click)="addSpecialCategoryTag()">
                        <i class="fa fa-plus me-1"></i>
                        Ekle
                      </button>
                    </div>
      
                    <div class="special-tag-empty" *ngIf="!specialCategoryTagItems?.length">
                      <i class="fa fa-tags me-2"></i>
                      Henüz etiket eklenmedi.
                    </div>
      
                    <div class="special-tag-row"
                      *ngFor="let item of specialCategoryTagItems; let i = index; trackBy: trackBySpecialCategoryTag">
                      <div class="special-tag-input-wrap">
                        <input type="text" class="form-control special-tag-input"
                          [class.is-invalid]="isSpecialCategoryTagInvalid(i)" [value]="item.label"
                          (input)="updateSpecialCategoryTag(i, 'label', $any($event.target).value)"
                          placeholder="Etiket giriniz" />
      
                        <div class="required mt-1" *ngIf="isSpecialCategoryTagInvalid(i)">
                          Etiket alanı boş olamaz.
                        </div>
                      </div>
      
                      <div class="sw-wrap">
                        <span class="sw-label">Alarm</span>
                        <label class="sw alarm">
                          <input type="checkbox" [checked]="item.alarm"
                            (change)="updateSpecialCategoryTag(i, 'alarm', $any($event.target).checked)">
                          <div class="sw-track"></div>
                          <div class="sw-thumb"></div>
                        </label>
                      </div>
      
                      <div class="sw-wrap">
                        <span class="sw-label">Pasif</span>
                        <label class="sw">
                          <input type="checkbox" [checked]="item.passive"
                            (change)="updateSpecialCategoryTag(i, 'passive', $any($event.target).checked)">
                          <div class="sw-track"></div>
                          <div class="sw-thumb"></div>
                        </label>
                      </div>
      
                      <button *ngIf="getSpecialCategoryTagLogCount(item) > 0" type="button" class="special-tag-icon-btn log"
                        (click)="openSpecialCategoryTagLogs(item)" title="Etiket Logları">
                        <i class="fa fa-history"></i>
                        <span class="special-tag-log-count">
                          {{ getSpecialCategoryTagLogCount(item) }}
                        </span>
                      </button>
      
                      <!-- <button
              type="button"
              class="special-tag-icon-btn delete"
              (click)="removeSpecialCategoryTag(i)"
              title="Etiketi Sil"
            >
              <i class="fa fa-trash"></i>
            </button> -->
                    </div>
                  </div>
                </div>
              </div>
            </app-cards>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-core-offcanvas>


<p-dialog
  [(visible)]="specialCategoryTagLogDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [style]="{ width: '620px', maxWidth: '95vw' }"
  [contentStyle]="{ 'max-height': '65vh', overflow: 'auto' }"
  styleClass="special-category-log-dialog compact"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <div class="mini-log-header">
      <i class="fa fa-history"></i>
      <div>
        <strong>Etiket Geçmişi</strong>
        <small>{{ selectedSpecialCategoryTagLabel || '-' }}</small>
      </div>
    </div>
  </ng-template>

  <div *ngIf="specialCategoryTagLogsLoading" class="mini-log-state">
    <i class="fa fa-spinner fa-spin"></i>
    Loglar yükleniyor...
  </div>

  <div
    *ngIf="!specialCategoryTagLogsLoading && !selectedSpecialCategoryTagLogs?.length"
    class="mini-log-state empty"
  >
    <i class="fa fa-circle-info"></i>
    Bu etiket için gösterilecek değişiklik bulunamadı.
  </div>

  <div
    *ngIf="!specialCategoryTagLogsLoading && selectedSpecialCategoryTagLogs?.length"
    class="mini-log-list"
  >
    <div
      class="mini-log-card"
      *ngFor="let log of selectedSpecialCategoryTagLogs"
      [ngClass]="log.typeClass"
    >
      <div class="mini-log-top">
        <div>
          <strong>{{ log.title }}</strong>

          <div class="mini-log-meta">
            <span>
              <i class="fa fa-user me-1"></i>
              {{ log.userName || '-' }}
            </span>

            <span>
              <i class="fa fa-calendar me-1"></i>
              {{ log.date | date : "dd.MM.yyyy HH:mm" }}
            </span>
          </div>
        </div>

        <span class="mini-log-badge" [ngClass]="log.typeClass">
          {{ log.badgeText }}
        </span>
      </div>

      <div class="mini-log-fields">
        <div
          class="mini-log-field"
          *ngFor="let change of log.changedFields"
        >
          <span class="mini-log-field-name">
            {{ change.label }}
          </span>

          <span class="mini-log-old">
            {{ change.oldText }}
          </span>

          <i class="fa fa-arrow-right mini-log-arrow"></i>

          <span class="mini-log-new">
            {{ change.newText }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-sm btn-light"
      (click)="specialCategoryTagLogDialogVisible = false"
    >
      Kapat
    </button>
  </ng-template>
</p-dialog>